import {ThemeTypographyNames} from '../../types';
import './assets/fonts/inter/inter.css';

const FontFamily = 'Inter';

export const TypographyVariants: ThemeTypographyNames = {
  paragraph_12_default: {
    fontFamily: FontFamily,
    fontSizePx: 12,
    fontWeight: 400,
    lineHeightPx: 19.2,
    textColor: 'content_mono_primary',
  },
  paragraph_12_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 12,
    fontWeight: 700,
    lineHeightPx: 19.2,
    textColor: 'content_mono_primary',
  },
  paragraph_14_default: {
    fontFamily: FontFamily,
    fontSizePx: 14,
    fontWeight: 400,
    lineHeightPx: 21,
    textColor: 'content_mono_primary',
  },
  paragraph_14_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 14,
    fontWeight: 700,
    lineHeightPx: 21,
    textColor: 'content_mono_primary',
  },
  paragraph_16_default: {
    fontFamily: FontFamily,
    fontSizePx: 16,
    fontWeight: 400,
    lineHeightPx: 24,
    textColor: 'content_mono_primary',
  },
  paragraph_16_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 16,
    fontWeight: 700,
    lineHeightPx: 24,
    textColor: 'content_mono_primary',
  },
  paragraph_20_default: {
    fontFamily: FontFamily,
    fontSizePx: 20,
    fontWeight: 400,
    lineHeightPx: 27,
    textColor: 'content_mono_primary',
  },
  paragraph_20_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 20,
    fontWeight: 700,
    lineHeightPx: 27,
    textColor: 'content_mono_primary',
  },
  paragraph_24_default: {
    fontFamily: FontFamily,
    fontSizePx: 24,
    fontWeight: 400,
    lineHeightPx: 31.2,
    textColor: 'content_mono_primary',
  },
  paragraph_24_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 24,
    fontWeight: 700,
    lineHeightPx: 31.2,
    textColor: 'content_mono_primary',
  },
  paragraph_32_default: {
    fontFamily: FontFamily,
    fontSizePx: 32,
    fontWeight: 400,
    lineHeightPx: 40,
    textColor: 'content_mono_primary',
  },
  paragraph_32_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 32,
    fontWeight: 700,
    lineHeightPx: 40,
    textColor: 'content_mono_primary',
  },
  paragraph_40_default: {
    fontFamily: FontFamily,
    fontSizePx: 40,
    fontWeight: 400,
    lineHeightPx: 46,
    textColor: 'content_mono_primary',
  },
  paragraph_40_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 40,
    fontWeight: 700,
    lineHeightPx: 46,
    textColor: 'content_mono_primary',
  },
  paragraph_56_default: {
    fontFamily: FontFamily,
    fontSizePx: 56,
    fontWeight: 400,
    lineHeightPx: 64.4,
    textColor: 'content_mono_primary',
  },
  paragraph_56_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 56,
    fontWeight: 700,
    lineHeightPx: 64.4,
    textColor: 'content_mono_primary',
  },

  inline_12_default: {
    fontFamily: FontFamily,
    fontSizePx: 12,
    fontWeight: 400,
    // lineHeightPx: 12,
    textColor: 'content_mono_primary',
  },
  inline_12_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 12,
    fontWeight: 700,
    // lineHeightPx: 12,
    textColor: 'content_mono_primary',
  },
  inline_14_default: {
    fontFamily: FontFamily,
    fontSizePx: 14,
    fontWeight: 400,
    // lineHeightPx: 14,
    textColor: 'content_mono_primary',
  },
  inline_14_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 14,
    fontWeight: 700,
    // lineHeightPx: 14,
    textColor: 'content_mono_primary',
  },
  inline_16_default: {
    fontFamily: FontFamily,
    fontSizePx: 16,
    fontWeight: 400,
    // lineHeightPx: 16,
    textColor: 'content_mono_primary',
  },
  inline_16_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 16,
    fontWeight: 700,
    // lineHeightPx: 16,
    textColor: 'content_mono_primary',
  },
  inline_20_default: {
    fontFamily: FontFamily,
    fontSizePx: 20,
    fontWeight: 400,
    // lineHeightPx: 20,
    textColor: 'content_mono_primary',
  },
  inline_20_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 20,
    fontWeight: 700,
    // lineHeightPx: 20,
    textColor: 'content_mono_primary',
  },
  inline_24_default: {
    fontFamily: FontFamily,
    fontSizePx: 24,
    fontWeight: 400,
    // lineHeightPx: 24,
    textColor: 'content_mono_primary',
  },
  inline_24_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 24,
    fontWeight: 700,
    // lineHeightPx: 24,
    textColor: 'content_mono_primary',
  },
  inline_32_default: {
    fontFamily: FontFamily,
    fontSizePx: 32,
    fontWeight: 400,
    // lineHeightPx: 32,
    textColor: 'content_mono_primary',
  },
  inline_32_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 32,
    fontWeight: 700,
    // lineHeightPx: 32,
    textColor: 'content_mono_primary',
  },
  inline_40_default: {
    fontFamily: FontFamily,
    fontSizePx: 40,
    fontWeight: 400,
    // lineHeightPx: 40,
    textColor: 'content_mono_primary',
  },
  inline_40_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 40,
    fontWeight: 700,
    // lineHeightPx: 40,
    textColor: 'content_mono_primary',
  },
  inline_56_default: {
    fontFamily: FontFamily,
    fontSizePx: 56,
    fontWeight: 400,
    // lineHeightPx: 56,
    textColor: 'content_mono_primary',
  },
  inline_56_emphasis: {
    fontFamily: FontFamily,
    fontSizePx: 56,
    fontWeight: 700,
    // lineHeightPx: 56,
    textColor: 'content_mono_primary',
  },
};
